import { render, staticRenderFns } from "./SignupAIStartupForm.vue?vue&type=template&id=69c5a10a"
import script from "./SignupAIStartupForm.vue?vue&type=script&lang=js"
export * from "./SignupAIStartupForm.vue?vue&type=script&lang=js"
import style0 from "./SignupAIStartupForm.vue?vue&type=style&index=0&id=69c5a10a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports